module.exports = __webpack_public_path__ + "static/the-guest-list-4f072318becdcf6cb60bcec0254bcb04.jpg";